import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-oee-state-remark',
  templateUrl: './oee-state-remark.component.html',
  styleUrls: ['./oee-state-remark.component.css']
})
export class OeeStateRemarkComponent implements OnInit {
    oeeStateKeyno;

    oeeStateRemarkKeyno;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.oeeStateKeyno = this.stateService.getStateParams()['oeestate_keyno'];
        this.oeeStateRemarkKeyno = this.stateService.getStateParams()['oeestateremark_keyno'];
    }

    private async loadEdit() {
        if (!!this.oeeStateKeyno && !!this.oeeStateRemarkKeyno) {
            this.edit = (await this.datatask.Post(247, {
                oeestate_keyno: this.oeeStateKeyno,
                oeestateremark_keyno: this.oeeStateRemarkKeyno,
            }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(248, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    oeestateremark_keyno: number;
    oeestateremark_name: string;
    oeestate_keyno: number;
    oeestate_name: string;
    show_remarktext: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('oeeStateRemark', {
//        templateUrl: 'views/components/views/oeeStateRemark/oeeStateRemark.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'oeeStateRemarkService', function ($stateParams, stateService, oeeStateRemarkService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let oeeStateKeyno = $stateParams.oeestate_keyno;
//            let oeeStateRemarkKeyno = $stateParams.oeestateremark_keyno;

//            vm.model = {
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadEdit() {
//                vm.model.edit = (await oeeStateRemarkService.getEdit({
//                    oeestate_keyno: oeeStateKeyno,
//                    oeestateremark_keyno: oeeStateRemarkKeyno
//                }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                oeeStateRemarkService.saveObj(vm.model.edit).then(function () {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, function () {
//                    vm.model.lockedSave = false;
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
